export default __webpack_public_path__ + "87418507c7542e7cae5ede0df7ce1c34.png";